// Máquina de estados de futuros (product=FUTURE):

/**
 * Subconjunto estrutural mínimo exigido pelas regras de estado abaixo. Tanto o
 * `Order` gerado (lista da rota /futures) quanto o `ListOrdersItem` enxuto do
 * widget de chat satisfazem este shape. Tipar pelo subconjunto — e não pelo
 * `Order` completo — evita acoplar as regras a campos que o item do tool de IA
 * não carrega (ex.: internalId/externalId), preservando a fonte única.
 */
export interface LinearOrderState {
  orderStatus: string;
  linear?: {
    closedAt: string | null;
    remainingQty: string;
  } | null;
}

/** Ordem pendente (limit ainda não preenchida) — pode ser cancelada */
export const isPendingOrder = (order: LinearOrderState) =>
  order.orderStatus === "NEW" || order.orderStatus === "PARTIALLY_FILLED";

/** Posição aberta — pode ser fechada (parcial ou total) */
export const isOpenPosition = (order: LinearOrderState) =>
  order.orderStatus === "FILLED" &&
  !!order.linear &&
  order.linear.closedAt === null &&
  Number(order.linear.remainingQty) > 0;

/** Posição totalmente fechada — só visualização (mostrar realizedPnl) */
export const isClosedPosition = (order: LinearOrderState) =>
  order.orderStatus === "FILLED" &&
  !!order.linear &&
  order.linear.closedAt !== null;
